import { History, Location } from 'history';

export function keepRootWithoutTrailingSlash(history: History, basename: string): () => void {
  if (!basename || basename === '/') {
    return () => {};
  }

  const rootPathname = basename;
  const rootPathnameWithSlash = `${basename}/`;

  const syncRootWithoutTrailingSlash = (location: Location) => {
    if (location.pathname !== '/' || window.location.pathname !== rootPathnameWithSlash) {
      return;
    }

    window.history.replaceState(
      window.history.state,
      document.title,
      `${rootPathname}${location.search}${location.hash}`,
    );
  };

  syncRootWithoutTrailingSlash(history.location);
  return history.listen(syncRootWithoutTrailingSlash);
}
